///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/apps/task/Agent/widgets/InvoiceInsightsWidget/WhoIsApprovingThisInvoice"/>
import { CalloutButton, FlexContent, FlexLayout, IconArrowsChevronRightRegular, IconToggleSparkleFill, LoaderBar, Text } from "@medius/ui-controls";
import { getLabelTranslation } from "Core/Medius.Core.Web/Scripts/lib/globalization";
import * as React from "react";
import { IAuthorizationHistory, IUser } from "Core/Medius.Core.Web/Scripts/Medius/apps/task/Agent/agentInterfaces";
import { getCurrent } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { NextApproverErrorMessage } from "./NextApproverErrorMessage";

interface WhoIsApprovingThisInvoiceProps {
    predictedApprovers: string[];
    previousApproversPerStep: IAuthorizationHistory;
    isError:boolean;
}

export function WhoIsApprovingThisInvoice({predictedApprovers, previousApproversPerStep, isError}: WhoIsApprovingThisInvoiceProps) {
    const currentUser = getCurrent();
    const currentUserDto: IUser = {
        firstName: currentUser.FirstName,
        lastName: currentUser.LastName,
        userName: currentUser.UserName
    };
    

    return <> { isError
        ? <NextApproverErrorMessage/> 
        : <div className="mediusAgent__widgetCard" data-testid="apa-copilot-predicted-next-approvers">
            <Text variant="heading3">
                {getLabelTranslation("#Core/WhoIsApprovingThisInvoice")}
            </Text>
            <FlexContent expand={false}>
                <FlexLayout spacerSize="vsmall" spacerMode="off" itemColumnSpacing="vsmall" verticalAlignment="center" direction="row">
                {predictedApprovers ? 
                    <>
                        {previousApproversPerStep && previousApproversPerStep.steps.length > 0 &&
                            <PreviousApprovers previousApproversPerStep={previousApproversPerStep}/>
                        }
                        <FlexContent expand={false}>
                            <FlexLayout 
                                spacerSize="vsmall" 
                                spacerMode="on"
                                itemColumnSpacing="vsmall" 
                                verticalAlignment="center" 
                                direction="row"
                            >
                                <Text alignment="center" variant="heading3" data-testid="apa-copilot-approverdisplayname-you">
                                    {`${getLabelTranslation("#Core/you")} (${getApproverDisplayName(currentUserDto)})`}
                                </Text>
                            </FlexLayout>
                        </FlexContent>
                        {predictedApprovers && predictedApprovers.length > 0 &&
                            <PredictedApprovers predictedApprovers={predictedApprovers}/>
                        }
                    </>
                    :
                    <LoaderBar spacerMode="on" data-testid="copilot-invoiceinsights-predictedApprovers-loaderBar"/>
                }
                </FlexLayout>
            </FlexContent>
    </div>
    }</>;
}

function PreviousApprovers({previousApproversPerStep}: {previousApproversPerStep: IAuthorizationHistory}) {
    return previousApproversPerStep.steps.map((usersInStep, index) => (
        <FlexContent key={index} expand={false}>
            <FlexLayout spacerSize="vsmall" spacerMode="on" itemColumnSpacing="vsmall" verticalAlignment="center" direction="row" data-testid="copilot-invoiceInsights-whoElseIsApprovingThisInvoice-list-previousApprovers">
                    <Text variant="body" data-testid={`copilot-invoiceinsights-previousApprovers-name-display-text-${index}`}>{getApproverDisplayName(usersInStep.historyItems[0].approver)}</Text>
                {usersInStep.historyItems.length > 1 && 
                <CalloutButton 
                    label={`+${usersInStep.historyItems.length-1}`}
                    variant="inline"
                    data-testid={`copilot-invoiceinsights-previousApprovers-showMorePreviousApprovers-button-${index}`}
                    description={getLabelTranslation("#Core/showMore")}
                    height="small"
                    width="content"
                    calloutProps={{
                        title: getLabelTranslation("#Core/detailsHeader"),
                        "data-testid": `copilot-invoiceinsights-previousApprovers-showMorePreviousApprovers-callout-${index}`,
                        renderContent: () => <>
                            {usersInStep.historyItems.slice(1).map((el, index) => <Text variant="paragraph" key={index}>{getApproverDisplayName(el.approver)}</Text>)}
                        </>,
                        width: "content",
                        showHeader: false
                    }}
                    />}
                <IconArrowsChevronRightRegular style={{paddingLeft:"8px", paddingRight:"8px"}}/>
            </FlexLayout>
        </FlexContent>
    ));
}

function PredictedApprovers({predictedApprovers}: {predictedApprovers: string[]}) {
    return <FlexContent expand={false}>
        <FlexLayout spacerSize="vsmall" spacerMode="on" itemColumnSpacing="vsmall" verticalAlignment="center" direction="row" data-testid="copilot-invoiceInsights-whoElseIsApprovingThisInvoice-list-predictedApprovers">
            <IconArrowsChevronRightRegular style={{paddingLeft:"8px", paddingRight:"8px"}}/>
            <IconToggleSparkleFill style={{paddingLeft:"8px", paddingRight:"8px"}}/>
            <Text spacerMode="off" variant="body" data-testid="copilot-invoiceinsights-predictedApprovers-name-display-text">{predictedApprovers[0]}</Text>
            {predictedApprovers.length > 1 && 
            <CalloutButton 
                data-testid="copilot-invoiceinsights-predictedApprovers-showMorePredictedApprovers-button"
                label={`+${predictedApprovers.length-1}`}
                variant="inline"
                description={getLabelTranslation("#Core/showMore")}
                height="small"
                width="content"
                calloutProps={{
                    title: getLabelTranslation("#Core/detailsHeader"),
                    "data-testid": "copilot-invoiceinsights-predictedApprovers-showMorePredictedApprovers-callout",
                    renderContent: () => <>
                        {predictedApprovers.slice(1).map((el, index) => <Text variant="paragraph" key={index}>{el}</Text>)}
                    </>,
                    width: "content",
                    showHeader: false
                }}
            />}
        </FlexLayout>
    </FlexContent>;
}

const getApproverDisplayName = (approver: IUser) => {
    if(!approver.firstName || !approver.lastName) {
        return approver.userName;
    }

    return approver.firstName + " " + approver.lastName[0];
};
